var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockSimpleOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.999 11H5.99902C5.44674 11 4.99902 11.4477 4.99902 12V26C4.99902 26.5523 5.44674 27 5.99902 27H25.999C26.5513 27 26.999 26.5523 26.999 26V12C26.999 11.4477 26.5513 11 25.999 11Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.499 11V6.5C11.499 5.30653 11.9731 4.16193 12.817 3.31802C13.661 2.47411 14.8055 2 15.999 2C17.1925 2 18.3371 2.47411 19.181 3.31802C20.0249 4.16193 20.499 5.30653 20.499 6.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSimpleOpen);
export default __webpack_public_path__ + "static/media/LockSimpleOpen.3349ae786fe95c0ae18631b006b33c88.svg";
export { ForwardRef as ReactComponent };